import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  IconButton,
  Snackbar,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  useTheme,
  useMediaQuery,
  Select,
  MenuItem
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import { tokens } from "../../components/Theme";
import DeleteOperationById from "../../api/operation/DeleteOperationById";
import GetOperationById from "../../api/operation/GetOperationById";
import CreateFertilizingOperation from "../../api/operation/CreateFertilizingOperation";
const initialPayload = [
  {
    appCropId: "20240625",
    appOperId: "2025",
    operDate: "2025-06-26",
    noOfWorkers: 1,

    fertilizers: [
      {
        fertType: "เคมี",
        commercialName: "abc",
        formulaN: 15,
        formulaP: 15,
        formulaK: 15,
        unitUsed: "กิโลกรัม",
        waterAmount: 100,
        reason: "บำรุงต้น ใบ",
      },
    ],
    equipments: [
      {
        equipCateId: 1,
        equipName: "รถแทรกเตอร/ 4 ล้อ ขนาด 15 แรงม้า",
        unitUsed: "คัน",
        amountUsed: 2,
      },
    ],
  },
];

export default function FertilizingTable({ appCropId }) {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [fertilizing, setFertilizing] = useState([]);

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [selectedDeleteId, setSelectedDeleteId] = useState(null);
  useEffect(() => {
    const fetchData = async () => {
      if (appCropId) {
        try {
          const res = await GetOperationById({ appCropId, appOperId: "OB" });
          setFertilizing(res);
        } catch (err) {
          console.error("Error fetching fertilizer stock:", err);
        }
      }
    };
    fetchData();
  }, [appCropId]);
  const handleChange = (index, key, value) => {
    const updated = [...fertilizing];
    updated[index].operDate =
      key === "operDate" ? value : updated[index].operDate;

    if (!updated[index].fertilizers[0]) updated[index].fertilizers[0] = {};
    if (!updated[index].equipments[0]) updated[index].equipments[0] = {};

    switch (key) {
      case "commercialName":
      case "fertType":
      case "formulaN":
      case "formulaP":
      case "formulaK":
      case "unitUsed":
      case "reason":
      case "waterAmount":
        updated[index].fertilizers[0][key] = value;
        break;
      case "equipName":
      case "amountUsed":
        updated[index].equipments[0][key] = value;
        break;
      default:
        updated[index][key] = value;
    }

    setFertilizing(updated);
  };

  const handleAdd = () => {
    const timestamp = Math.floor(Date.now() / 1000);
    setFertilizing([
      ...fertilizing,
      {
        appCropId,
        appOperId: "OB" + timestamp,
        operDate: "",
        fertilizers: [
          {
            fertType: "",
            commercialName: "",
            formulaN: 0,
            formulaP: 0,
            formulaK: 0,
            unitUsed: "",
            waterAmount: 0,
            reason: "",
          },
        ],
        equipments: [
          {
            equipCateId: 0,
            equipName: "",
            unitUsed: "",
            amountUsed: 0,
          },
        ],
      },
    ]);
  };
  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  const handleDelete = (index) => {
    setFertilizing(fertilizing.filter((_, i) => i !== index));
  };
  const openDeleteDialog = (id) => {
    setSelectedDeleteId(id);
    setDeleteDialogOpen(true);
  };
  const confirmDelete = async () => {
    try {
      await DeleteOperationById({ appOperId: selectedDeleteId });
      setFertilizing((prev) =>
        prev.filter((item) => item.appOperId !== selectedDeleteId)
      );
      setSnackbarSeverity("success");
      setSnackbarMessage("ลบรายการสำเร็จ");
    } catch (err) {
      setSnackbarSeverity("error");
      setSnackbarMessage("เกิดข้อผิดพลาดในการลบ");
    } finally {
      setDeleteDialogOpen(false);
      setOpenSnackbar(true);
    }
  };
  const handleSave = async () => {
    const grouped = {};

    fertilizing.forEach((item) => {
      const key = item.operDate;

      if (!grouped[key]) {
        grouped[key] = {
          appCropId: item.appCropId,
          appOperId: item.appOperId,
          operDate: item.operDate,
          fertilizers: [],
          equipments: [],
        };
      }

      grouped[key].fertilizers.push(...(item.fertilizers || []));
      grouped[key].equipments.push(...(item.equipments || []));
    });

    const result = Object.values(grouped);
    // console.log("sort data:", JSON.stringify(result, null, 2));
    const results = await CreateFertilizingOperation(result);
    const hasError = results.some((r) => r.status !== 200);
    if (hasError) {
      setSnackbarSeverity("error");
      setSnackbarMessage("บางรายการบันทึกไม่สำเร็จ");
    } else {
      setSnackbarSeverity("success");
      setSnackbarMessage("บันทึกสำเร็จทั้งหมด");
    }
    setOpenSnackbar(true);
  };

  return (
    <Box p={2}>
      <Box
        width="100%"
        sx={{ backgroundColor: colors.greenAccent[300] }}
        display="flex"
        justifyContent="center"
      >
        <Typography
          p={isMobile ? 1 : 2}
          variant={isMobile ? "body" : "h6"}
          fontWeight="bold"
          color="#fff"
        >
          ตารางการให้ปุ๋ย
        </Typography>
      </Box>

      <Box maxWidth={isMobile ? "320px" : "none"}>
        <TableContainer component={Paper} sx={{ mt: 2, overflowX: "auto" }}>
          <Table size="small" sx={{ minWidth: 800 }}>
            <TableHead>
              <TableRow>
                <TableCell>#</TableCell>
                <TableCell>วันที่</TableCell>
                <TableCell>ชนิดปุ๋ย</TableCell>
                <TableCell>ชื่อปุ๋ย</TableCell>
                <TableCell>สูตร (N-P-K)</TableCell>
                <TableCell>หน่วยที่ใช้</TableCell>
                <TableCell>น้ำ (ลิตร)</TableCell>
                <TableCell>เหตุผล</TableCell>
                <TableCell>อุปกรณ์ที่ใช้</TableCell>
                <TableCell>จำนวน</TableCell>
                <TableCell align="center">ลบ</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {fertilizing.map((row, index) => (
                <TableRow key={index}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>
                    <TextField
                      type="date"
                      size="small"
                      value={row.operDate}
                      onChange={(e) =>
                        handleChange(index, "operDate", e.target.value)
                      }
                    />
                  </TableCell>
                  <TableCell>
                    <Select
                      size="small"
                      fullWidth
                      value={row.fertilizers?.[0]?.fertType ?? ""}
                      onChange={(e) =>
                        handleChange(index, "fertType", e.target.value)
                      }
                      displayEmpty
                    >
                      <MenuItem value="">
                        <em>เลือกชนิดปุ๋ย</em>
                      </MenuItem>
                      <MenuItem value="เคมี">เคมี</MenuItem>
                      <MenuItem value="อินทรีย์">อินทรีย์</MenuItem>
                    </Select>
                  </TableCell>

                  <TableCell>
                    <TextField
                      sx={{
                        minWidth: isMobile ? "90px" : "100px",
                      }}
                      size="small"
                      value={row.fertilizers?.[0]?.commercialName || ""}
                      onChange={(e) =>
                        handleChange(index, "commercialName", e.target.value)
                      }
                    />
                  </TableCell>
                  <TableCell>
                    <Box display="flex" gap={0.5}>
                      <TextField
                        size="small"
                        type="number"
                        value={row.fertilizers?.[0]?.formulaN || 0}
                        onChange={(e) =>
                          handleChange(index, "formulaN", e.target.value)
                        }
                        sx={{ width: 60 }}
                      />
                      <TextField
                        size="small"
                        type="number"
                        value={row.fertilizers?.[0]?.formulaP || 0}
                        onChange={(e) =>
                          handleChange(index, "formulaP", e.target.value)
                        }
                        sx={{ width: 60 }}
                      />
                      <TextField
                        size="small"
                        type="number"
                        value={row.fertilizers?.[0]?.formulaK || 0}
                        onChange={(e) =>
                          handleChange(index, "formulaK", e.target.value)
                        }
                        sx={{ width: 60 }}
                      />
                    </Box>
                  </TableCell>
                  <TableCell>
                    <TextField
                      sx={{
                        minWidth: isMobile ? "100px" : "100px",
                      }}
                      size="small"
                      value={row.fertilizers?.[0]?.unitUsed || ""}
                      onChange={(e) =>
                        handleChange(index, "unitUsed", e.target.value)
                      }
                    />
                  </TableCell>
                  <TableCell>
                    <TextField
                      sx={{
                        minWidth: isMobile ? "80px" : "100px",
                      }}
                      size="small"
                      type="number"
                      value={row.fertilizers?.[0]?.waterAmount || 0}
                      onChange={(e) =>
                        handleChange(index, "waterAmount", e.target.value)
                      }
                    />
                  </TableCell>
                  <TableCell>
                    <TextField
                      sx={{
                        minWidth: isMobile ? "130px" : "150px",
                      }}
                      size="small"
                      value={row.fertilizers?.[0]?.reason || ""}
                      onChange={(e) =>
                        handleChange(index, "reason", e.target.value)
                      }
                    />
                  </TableCell>
                  <TableCell>
                    <TextField
                      sx={{
                        minWidth: isMobile ? "130px" : "150px",
                      }}
                      size="small"
                      value={row.equipments?.[0]?.equipName || ""}
                      onChange={(e) =>
                        handleChange(index, "equipName", e.target.value)
                      }
                    />
                  </TableCell>
                  <TableCell>
                    <TextField
                      sx={{
                        minWidth: isMobile ? "60px" : "60px",
                      }}
                      size="small"
                      type="number"
                      value={row.equipments?.[0]?.amountUsed || 0}
                      onChange={(e) =>
                        handleChange(index, "amountUsed", e.target.value)
                      }
                    />
                  </TableCell>
                  <TableCell align="center">
                    <IconButton
                      color="error"
                      onClick={() => openDeleteDialog(row.appOperId)}  // ใช้ ID ของรายการ
                    >
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}

              <TableRow>
                <TableCell colSpan={10} align="center">
                  <Button
                    startIcon={<AddIcon />}
                    onClick={handleAdd}
                    variant="outlined"
                  >
                    เพิ่มแถว
                  </Button>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      <Box textAlign="center" mt={3}>
        <Button
          variant="contained"
          sx={{ backgroundColor: colors.greenAccent[400] }}
          onClick={handleSave}
        >
          บันทึกข้อมูล
        </Button>
      </Box>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={2000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "center", horizontal: "center" }}
        sx={{
          "& .MuiSnackbarContent-root": {
            justifyContent: "center",
            minWidth: "200px",
            textAlign: "center",
          },
        }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
          variant="filled"
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>

      <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
        <DialogTitle>ยืนยันการลบ</DialogTitle>
        <DialogContent>
          <Typography>คุณต้องการลบรายการนี้ใช่หรือไม่?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialogOpen(false)}>ยกเลิก</Button>
          <Button color="error" onClick={confirmDelete}>
            ลบ
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
